import { HotelProvider } from '@graphql/generated';

export enum HotelDetailsQueryParams {
  eventId = 'eventId',
  joyPlaceId = 'joyPlaceId',
  customUrl = 'customUrl',
  source = 'source',
  utm_source_secondary = 'utm_source_secondary',
  utm_source = 'utm_source',
  utm_medium = 'utm_medium',
  utm_campaign = 'utm_campaign',
  hasExternalLink = 'hasExternalLink',

  idType = 'idType'
}

export enum HotelDetailsIdType {
  stays = 'stays',
  joy = 'joy',
  hotels = 'hotels'
}

export enum HotelIdType {
  stays = 'nuitee',
  joy = 'joyPlace',
  hotels = 'zh'
}

export type HotelDetailsParamsType = {
  clientReference: string;
  provider?: HotelProvider;
  externalPDPUrl?: string | null;
  hotelWebsite?: string | null;
  customUrl?: string | null;
  googleMaps?: {
    gplid?: string | null;
    name?: string | null;
    address?: string | null;
    lat?: number | null;
    lng?: number | null;
  };
  utm_source?: string | null;
  utm_source_secondary?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
  hasExternalLink?: string;
  checkIn?: string;
  checkOut?: string;
  isCheckInOrCheckoutValid: boolean;
  source?: string | null;
  sourceType: HotelDetailsIdType;
  currencyCode?: string;
};

export interface TelHotelDetailsRedirectParams {
  destinationName?: string;
  destinationUrl?: URL;
  onTelemetrySend?: () => void;
  clientReference?: string;
  externalPDPUrl?: string | null;
  hotelWebsite?: string | null;
  googleMaps?: {
    gplid?: string | null;
    name?: string | null;
    address?: string | null;
    lat?: number | null;
    lng?: number | null;
  };
  utm_source?: string | null;
  utm_source_secondary?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
}
